export default __webpack_public_path__ + "static/about-cd4bb200ecd1ee1ece3aa4469b406765.png";